module.exports = __webpack_public_path__ + "static/media/task.8cbf70fa.svg";